import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_module_information: { message: "idle" },
};

export const retrieve_module_information_Slice = createSlice({
 name: "retrieve_module_information",
 initialState,
 reducers: {
  success_retrieve_module_information: (state, action) => {
   state.retrieve_module_information = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_module_information: (state, action) => {
   state.retrieve_module_information = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_module_information: (state) => {
   state.retrieve_module_information = { status: app_consts.IDLE };
  },
  loading_retrieve_module_information: (state) => {
   state.retrieve_module_information = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_module_information, fail_retrieve_module_information, reset_retrieve_module_information, loading_retrieve_module_information } = retrieve_module_information_Slice.actions;

export default retrieve_module_information_Slice.reducer;